import { defineMessages } from "react-intl";

const messages = defineMessages({
  buttonDisabledWarning: {
    id: "view.selectBar.button.email.buttonDisabledWarning",
    defaultMessage:
      "No emails exist on records selected. Please adjust selection to include records that have emails.",
    description: "Email button on a selected entities bar - button disabled warning",
  },
  buttonDisabledWarningForMapMode: {
    id: "view.selectBar.button.email.buttonDisabledWarningForMapMode",
    defaultMessage:
      "No emails exist on records in lasso selection. Please adjust the lasso selection to include records that have emails.",
    description: "Email button on a selected entities bar - button disabled warning for map",
  },
  modalAssociationsSentCancel: {
    id: "view.selectBar.button.email.modalAssociationsSentCancel",
    defaultMessage: "Cancel",
    description: "Email button on a selected entities bar - modal associations sent cancel",
  },
  modalAssociationsSentOk: {
    id: "view.selectBar.button.email.modalAssociationsSentOk",
    defaultMessage: "Continue",
    description: "Email button on a selected entities bar - modal associations sent ok",
  },
  modalAssociationsSentText: {
    id: "view.selectBar.button.email.modalAssociationsSentText",
    defaultMessage:
      "We can only send deal emails by way of their associations. Deals that aren’t linked to a Company or Person will be skipped. Email activities logged will be associated with the Company or Person.",
    description: "Email button on a selected entities bar - modal associations sent text",
  },
  modalAssociationsSentTitle: {
    id: "view.selectBar.button.email.modalAssociationsSentTitle",
    defaultMessage: "Emails will be sent to the associated Companies or People",
    description: "Email button on a selected entities bar - modal associations sent title",
  },
  modalCompanyPersonRecipientType: {
    id: "view.selectBar.button.email.modalCompanyPersonRecipientType",
    defaultMessage: "People Associated With Companies",
    description: "Email button on a selected entities bar - modal company person recipient type",
  },
  modalEntitySelectorCancelText: {
    id: "view.selectBar.button.email.modalEntitySelectorCancelText",
    defaultMessage: "Cancel",
    description: "Email button on a selected entities bar - modal Cancel text",
  },
  modalEntitySelectorOkText: {
    id: "view.selectBar.button.email.modalEntitySelectorOkText",
    defaultMessage: "Continue",
    description: "Email button on a selected entities bar - modal ok text",
  },
  modalEntitySelectorText: {
    id: "view.selectBar.button.email.modalEntitySelectorText",
    defaultMessage:
      "You have selected pins of different record types. To send an email, choose a single record type. Records without emails will be excluded.",
    description: "Email button on a selected entities bar - modal entity selector",
  },
  modalEntitySelectorTitle: {
    id: "view.selectBar.button.email.modalEntitySelectorTitle",
    defaultMessage: "Select record type for email",
    description: "Email button on a selected entities bar - modal title",
  },
  modalNotAllEntitiesHaveEmailCancel: {
    id: "view.selectBar.button.email.modalNotAllEntitiesHaveEmailCancel",
    defaultMessage: "Cancel",
    description:
      "Email button on a selected entities bar - modal not all entities have email cancel",
  },
  modalNotAllEntitiesHaveEmailOk: {
    id: "view.selectBar.button.email.modalNotAllEntitiesHaveEmailOk",
    defaultMessage: "Continue",
    description: "Email button on a selected entities bar - modal not all entities have email ok",
  },
  modalNotAllEntitiesHaveEmailText: {
    id: "view.selectBar.button.email.modalNotAllEntitiesHaveEmailText",
    defaultMessage:
      "Only records with email addresses will be included. The number of records emailed will be smaller than the number of records selected.",
    description: "Email button on a selected entities bar - modal not all entities have email text",
  },
  modalNotAllEntitiesHaveEmailTitle: {
    id: "view.selectBar.button.email.modalNotAllEntitiesHaveEmail",
    defaultMessage: "Some selected records do not have emails",
    description: "Email button on a selected entities bar - modal not all entities have email",
  },
  modalSingleEntitySelectorText: {
    id: "view.selectBar.button.email.modalSingleEntitySelectorText",
    defaultMessage: "Would you like to email companies or people associated with {entityType}?",
    description: "Email button on a selected entities bar - modal entity selector",
  },
  syncModalCancel: {
    id: "view.selectBar.button.email.sycModalCancel",
    defaultMessage: "Maybe Later",
    description: "Email button on a selected entities bar - Sync modal cancel",
  },
  syncModalFailedConnectionOk: {
    id: "view.selectBar.button.email.syncModalFailedConnectionOk",
    defaultMessage: "Reconnect my email",
    description: "Email button on a selected entities bar - Sync modal with failed connection Ok",
  },
  syncModalFailedConnectionText: {
    id: "view.selectBar.button.email.syncModalFailedConnectionText",
    defaultMessage:
      "Let’s get you synced again. Reconnecting only takes a few seconds - you’ll be back on track in no time! And don’t worry, all your settings and preferences will be saved.",
    description:
      "Email button on a selected entities bar - Sync modal with failed connection title",
  },
  syncModalFailedConnectionTitle: {
    id: "view.selectBar.button.email.syncModalFailedConnectionTitle",
    defaultMessage: "Uh oh! Your email isn’t connected",
    description:
      "Email button on a selected entities bar - Sync modal with failed connection title",
  },
  syncModalNoConnectionOk: {
    id: "view.selectBar.button.email.sycModalNoConnectionOk",
    defaultMessage: "Sync my email",
    description: "Email button on a selected entities bar - Sync modal with no connection Ok",
  },
  syncModalNoConnectionText: {
    id: "view.selectBar.button.email.syncModalNoConnectionText",
    defaultMessage:
      "When you sync your email, MMC will: {br} 1. Auto-log the activity for you{br} 2. Save the content of the email to the activity{br} 3. Track opens and clicks{br}{br} {icon} <b>Pro Tip:</b> Use Lasso to send emails in bulk",
    description: "Email button on a selected entities bar - Sync modal with no connection title",
  },
  syncModalNoConnectionTitle: {
    id: "view.selectBar.button.email.sycModalNoConnectionTitle",
    defaultMessage: "Set up email in Map My Customers ",
    description: "Email button on a selected entities bar - Sync modal with no connection title",
  },
  title: {
    id: "view.selectBar.button.email.title",
    defaultMessage: "Email",
    description: "Email button on a selected entities bar - title",
  },
  whatAboutDeals: {
    id: "view.selectBar.button.email.whatAboutDeals",
    defaultMessage: "What about Deals?",
    description: "Email button on a selected entities bar - what about deals",
  },
  whatAboutDealsText: {
    id: "view.selectBar.button.email.whatAboutDealsText",
    defaultMessage:
      "We can only send email deals by way of their associations. Deals that aren't linked to a Company or Person will be skipped.",
    description: "Email button on a selected entities bar - what about deals text",
  },
});

export default messages;
